import { render, staticRenderFns } from "./ResearchGEMDataTable.vue?vue&type=template&id=feedfb50"
import script from "./ResearchGEMDataTable.vue?vue&type=script&lang=js"
export * from "./ResearchGEMDataTable.vue?vue&type=script&lang=js"
import style0 from "./ResearchGEMDataTable.vue?vue&type=style&index=0&id=feedfb50&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feedfb50')) {
      api.createRecord('feedfb50', component.options)
    } else {
      api.reload('feedfb50', component.options)
    }
    module.hot.accept("./ResearchGEMDataTable.vue?vue&type=template&id=feedfb50", function () {
      api.rerender('feedfb50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchGEMDataTable.vue"
export default component.exports